export default __webpack_public_path__ + "static/media/tabla11.21104fcc.png";